class BundleBuilder extends HTMLElement {
    constructor() {
        super();

        console.log('working.....')
        
        this.productWrapperSelector = '[js-product-wrapper]';
        this.addToSetBtn = '[js-ats-btn]';
        this.addQtysBtn = '[js-qty-btn]';
        this.incrementBtnSelector = '[js-quantity-increment]';
        this.decrementBtnSelector = '[js-quantity-decrement]';
        this.quantityInputSelector = '[js-quantity-input]';
        this.productBundleCountBadge = '[js-product-bundle-count]';

        this.selectionCountWrapper = this.querySelector('[js-bundle-selection-count-wrap]');
        this.selectionCount = this.querySelector('[js-selection-count]');
        this.addToCartBtn = this.querySelector('[js-bundle-addToCart-btn]');
        this.sellingPlanSelect = this.querySelector('[js-custom-option-select]');
        this.totalPrice = this.querySelectorAll('[js-total-price]');
        this.totalDiscountedPrice = this.querySelectorAll('[js-total-discounted-price]');
        this.currencyFormat = this.querySelector('[currency-format]').getAttribute('currency-format');
        this.oneTimePrice = this.querySelector('[onetime-price]').getAttribute('onetime-price');
        this.oneTimeStrikePrice = this.querySelector('[onetime-strike-price]').getAttribute('onetime-strike-price');
        this.subsciptionPrice = this.querySelector('[subsciption-price]').getAttribute('subsciption-price');
        this.subsciptionStrikePrice = this.querySelector('[subscription-strike-price]').getAttribute('subscription-strike-price');


        this.subscriptionDiscountedPriceEls = this.querySelectorAll('[js-skio-subsciption-discounded-price]');
        this.subscriptionTotalPriceEls = this.querySelectorAll('[js-skio-subsciption-total-price]');
        this.oneTimeTotalPriceEls = this.querySelectorAll('[js-skio-one-time-total-price]');

        this.products = [];
        this.sellingPlanId = this.sellingPlanSelect.value;
        this.sellingPlanName = null;

        this.oneTimeRadio = this.querySelector('[js-skio-bundle-onetime]');
        this.subscriptionRadio = this.querySelector('[js-skio-bundle-subscription]');
        this.selectField = this.querySelector('[js-skio-bundle-select-field]');

        this.handleSubscriptionToggle();

        this.addEventListener('click', (event) => {
            
            this.querySelectorAll(this.addToSetBtn).forEach(addToSet => {
                if (addToSet.contains(event.target)) {
                    const parent = addToSet.closest(this.productWrapperSelector);
                    const quantityField = parent.querySelector(this.quantityInputSelector);
                    quantityField.stepUp();
                    parent.classList.add('selected');
                    this.addProductToBox(parent);
                    // this.updateProductCountBadge(parent);
                    this.updatePrice();
                }
            });

            this.querySelectorAll(this.incrementBtnSelector).forEach(incrementBtn => {
                if (incrementBtn.contains(event.target)) {
                    const parent = incrementBtn.closest(this.productWrapperSelector);
                    const quantityField = parent.querySelector(this.quantityInputSelector);
                    quantityField.stepUp();

                    this.addProductToBox(parent);
                    // this.updateProductCountBadge(parent);
                    this.updatePrice();
                }
            });

            this.querySelectorAll(this.decrementBtnSelector).forEach(decrementBtn => {
                if (decrementBtn.contains(event.target)) {
                    const parent = decrementBtn.closest(this.productWrapperSelector);
                    const currentProductId = Number(parent.dataset.productId);
                    const quantityField = parent.querySelector(this.quantityInputSelector);

                    if (Number(quantityField.value) > 0) {
                        quantityField.stepDown();
                    }

                    this.removeProductFromBox(currentProductId, parent);
                    // this.updateProductCountBadge(parent);
                    this.updatePrice();
                }
            });

            this.sellingPlanId = this.sellingPlanSelect.value;
            if (this.sellingPlanSelect) {
                const initialOption = this.sellingPlanSelect.options[this.sellingPlanSelect.selectedIndex];
                this.sellingPlanName = initialOption?.getAttribute('data-plan-name') || null;
            }
        });
        

        this.sellingPlanSelect.addEventListener('change', (e) => {
            this.sellingPlanId = e.currentTarget.value;
            this.updatePrice();
            const selectedOption = e.target.options[e.target.selectedIndex];
            this.sellingPlanName = selectedOption.getAttribute('data-plan-name');
        });

        this.addToCartBtn.addEventListener('click', () => {
            let cartItems = [];

            this.products.forEach(product => {
                const itemFound = cartItems.find(item => item.id === product.id);
                if (itemFound) {
                    cartItems = cartItems.map(item => {
                        if (item.id === product.id) {
                            item.quantity += product.quantity;
                        }
                        return item;
                    });
                } else {
                    cartItems.push({
                        quantity: product.quantity,
                        id: product.id,
                        selling_plan: this.subscriptionRadio?.checked ? this.sellingPlanId : null,
                        properties: {
                            _dynamicBoxIndex: new Date().getTime(),
                            _dynamicBoxId: skioDynamicBoxId,
                            _sellingPlanName:this.subscriptionRadio?.checked ? this.sellingPlanName : null,
                            _productUrl: this.getAttribute('data-product-url'),
                        }
                    });
                }
            });

            this.addToCartBtn.classList.add('loading');
            this.addToCartBtn.querySelector('.loading__spinner')?.classList.remove('hidden');
            this.addToCart(cartItems);
        });
    }
    
    updatePrice() {
        let discountedPrice = 0;
        let originalPrice = 0;

        this.products.forEach(product => {
            originalPrice += product.price;
        });

       let customPrice = this.products.reduce((sum, product) => sum + (product.customPrice || 0),0);


        if (typeof skioBynamicSellingPlanGroup !== "undefined") {
            const selectedSellingPlan = skioBynamicSellingPlanGroup[`gid://shopify/SellingPlan/${this.sellingPlanId}`];

            this.products.forEach(product => {
                discountedPrice += selectedSellingPlan?.variantMapping[`gid://shopify/ProductVariant/${product.id}`]?.adjustedPrice || product.price;
            });
        }

        this.subscriptionDiscountedPriceEls.forEach(subscriptionDiscountedPriceEl=>{
            // subscriptionDiscountedPriceEl.innerText = `$${discountedPrice.toFixed(0)}`
            subscriptionDiscountedPriceEl.innerText = `$${parseFloat(this.subsciptionPrice).toFixed(2)} ${this.currencyFormat}`;
        })
        this.subscriptionTotalPriceEls.forEach(subscriptionTotalPriceEl=>{
            // subscriptionTotalPriceEl.innerText = `$${originalPrice.toFixed(0)}`
            subscriptionTotalPriceEl.innerText = `$${parseFloat(this.subsciptionStrikePrice).toFixed(2)}`
        })
        this.oneTimeTotalPriceEls.forEach(oneTimeTotalPriceEl=>{
            // oneTimeTotalPriceEl.innerHTML = `$${customPrice.toFixed(2)} <s>$${originalPrice.toFixed(0)}</s>`
            oneTimeTotalPriceEl.innerHTML = `$${parseFloat(this.oneTimePrice).toFixed(2)} ${this.currencyFormat} <s>$${parseFloat(this.oneTimeStrikePrice).toFixed(2)}</s>`
        })

        this.updateAddToCartButtonPrice(originalPrice, discountedPrice);
    }

    updateAddToCartButtonPrice(originalPrice, discountedPrice) {
        if (this.subscriptionRadio?.checked) {
            this.totalPrice.forEach(price=>{
                price.innerText = `$${parseFloat(this.oneTimeStrikePrice).toFixed(2)}`;
            });
            this.totalDiscountedPrice.forEach(discoundPrice => {
                discoundPrice.innerText = `$${parseFloat(this.subsciptionPrice).toFixed(2)} ${this.currencyFormat}`;
            });

            const servingValue = parseInt(this.querySelector('[data-serving-value]').getAttribute('data-serving-value'));
            const perServingTag = this.querySelector('[js-per-serving]');

            // perServingTag.innerText = `$${(discountedPrice / servingValue).toFixed(2)}`;
            perServingTag.innerText = `$1.63`;

            if (document?.querySelector('[js-byob-servings]')?.style) {
                document.querySelector('[js-byob-servings]').style.opacity = 1;
            }

        } else {

            let customPrice = this.products.reduce((sum, product) => sum + (product.customPrice || 0),0);

            this.totalPrice.forEach(price=>{
                price.innerText = `$${parseFloat(this.oneTimeStrikePrice).toFixed(2)} ${this.currencyFormat}`;
            });

            this.totalDiscountedPrice.forEach(discoundPrice => {
                discoundPrice.innerText = `$${parseFloat(this.oneTimePrice).toFixed(2)} ${this.currencyFormat}`;
            });

            const servingValue = parseInt(this.querySelector('[data-serving-value]').getAttribute('data-serving-value'));
            const perServingTag = this.querySelector('[js-per-serving]');

            // perServingTag.innerText = `$${(originalPrice / servingValue).toFixed(2)}`;
            // perServingTag.innerText = `$${customPrice}`;
            perServingTag.innerText = `$1.86`;

        }
    }
    addProductToBox(parent) {
        const imageUrl = parent.dataset.productImageUrl;
        const variantId = Number(parent.dataset.variantId);
        const productId = Number(parent.dataset.productId);
        const title = parent.dataset.productTitle;
        const price = Number(parent.dataset.productPrice);
        const customPrice = Number(parent.dataset.productCustomPrice) || 0;

        this.products.push({
            id: variantId,
            productId: productId,
            imageUrl,
            title,
            price,
            customPrice,
            quantity: 1,
        });

        this.updateStatus();
    }
    removeProductFromBox(id, parent) {
        const otherProducts = this.products.filter(product => product.productId !== id);
        const currentProducts = this.products.filter(product => product.productId == id);
        currentProducts.splice(0, 1);

        if (currentProducts.length === 0) {
            parent.classList.remove('selected');
        }

        this.products = [...currentProducts, ...otherProducts];
        this.updateStatus();
    }
    updateStatus() {
        if (this.products.length >= 4) {
            this.querySelectorAll(this.incrementBtnSelector).forEach(item => item.classList.add('disabled'));
            this.querySelectorAll(this.addToSetBtn).forEach(item => item.classList.add('disabled'));
            this.addToCartBtn.classList.add('is-visible');
            this.selectionCountWrapper.classList.remove('is-visible');
        } else {
            this.querySelectorAll(this.incrementBtnSelector).forEach(item => item.classList.remove('disabled'));
            this.querySelectorAll(this.addToSetBtn).forEach(item => item.classList.remove('disabled'));
            this.addToCartBtn.classList.remove('is-visible');
            this.selectionCountWrapper.classList.add('is-visible');
        }

        this.selectionCount.innerHTML = `${4 - this.products.length}`;
    }
    updateProductCountBadge(parent) {
        const quantityField = parent.querySelector(this.quantityInputSelector);
        const badge = parent.querySelector(this.productBundleCountBadge);
        const qty = Number(quantityField.value);

        if (qty >= 1) {
            badge.classList.remove('hidden');
            badge.innerText = qty;
        } else {
            badge.classList.add('hidden');
            badge.innerText = 0;
        }
    }
    handleSubscriptionToggle() {
        if (!this.oneTimeRadio || !this.subscriptionRadio || !this.selectField) return;

        const toggleVisibility = () => {
            // if (this.subscriptionRadio.checked) {
            //     this.selectField.style.maxHeight = "1000px";
            //     this.selectField.style.opacity = "1";
            //     this.selectField.style.visibility = "visible";

            // } else if (this.oneTimeRadio.checked) {
            //     this.selectField.style.maxHeight = "0px";
            //     this.selectField.style.opacity = "0";
            //     this.selectField.style.visibility = "hidden";
            // }
            this.updatePrice();
        };

        this.selectField.addEventListener('click', () => {
            if (this.subscriptionRadio.checked) return;
            this.subscriptionRadio.checked = true;
            this.subscriptionRadio.dispatchEvent(new Event('change', { bubbles: true }));
        });

        toggleVisibility();
        this.oneTimeRadio.addEventListener("change", toggleVisibility);
        this.subscriptionRadio.addEventListener("change", toggleVisibility);
    }
    async addToCart(products) {
        const requestBody = { items: products };

        try {
            const resp = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
                method: 'POST',
                body: JSON.stringify(requestBody),
                headers: { "Content-Type": "application/json" },
            });

            const data = await resp.json();

            document.dispatchEvent(new CustomEvent("cart:refresh"));
            if (document.getElementById('Cart-Drawer')) {
                document.body.classList.add('open-cc', 'open-cart');
                document.getElementById('Cart-Drawer').classList.add('active');
            }

            this.addToCartBtn.classList.remove('loading');
            this.addToCartBtn.querySelector('.loading__spinner')?.classList.add('hidden');
        } catch (err) {
            console.error({ err });
        }
    }
}

customElements.define('bundle-builder', BundleBuilder);
